import iconHomeNav from '../assets/art/icon-home-nav.svg?raw'
import { svgFromRaw } from '../assets/art/svg'
import { el } from '../dom'
import type { GameContext, GameModule, Unmount } from '../games/types'
import { COPY } from './copy'

export function mountGameScreen(
  root: HTMLElement,
  game: GameModule,
  ctx: GameContext,
): Unmount {
  const home = el(
    'button',
    {
      className: 'home-btn',
      testId: 'home-button',
      attrs: { type: 'button', 'aria-label': COPY.home },
    },
    [svgFromRaw(iconHomeNav, 'home-btn__icon')],
  )
  home.addEventListener('click', () => ctx.requestHome())
  const stage = el('div', { className: 'game-stage', testId: 'game-screen' })
  root.append(home, stage)
  const unmountGame = game.mount(stage, ctx)
  return () => {
    unmountGame()
    root.replaceChildren()
  }
}
